export type ProductRequestMessages = {
  // Success Messages
  activateProductSuccess: string;
  productCreateSuccess: string;
  productUpdateSuccess: string;
  imageCreateSuccess: string;
  imageUpdateSuccess: string;

  // Error Messages
  activateProductError: string;
  notFoundError: string;
  productCreateError: string;
  productUpdateError: string;
  notFoundAlt: string;
  errorToLoad: string;
  notFoundDescription: string;
  imageCreateError: string;
  imageUpdateError: string;
  
  // Validation Messages
  codeRequiredForSku: string;
  titleRequiredForSku: string;
  codeAndTitleRequiredForSku: string;
};

export const PRODUCT_REQUEST_MESSAGES: ProductRequestMessages = {
  // Success Messages
  activateProductSuccess: "Status do produto alterado com sucesso.",
  productCreateSuccess: "Produto criado com sucesso.",
  productUpdateSuccess: "Produto atualizado com sucesso.",
  imageCreateSuccess: "Imagem do produto criada com sucesso.",
  imageUpdateSuccess: "Imagem do produto atualizada com sucesso.",

  // Error Messages
  activateProductError: "Erro ao alterar status do produto.",
  notFoundError: "Produto não encontrado.",
  productCreateError: "Erro ao criar o produto.",
  productUpdateError: "Erro ao atualizar o produto.",
  notFoundAlt: "Produto não encontrado.",
  errorToLoad: "Erro ao carregar o produto.",
  notFoundDescription: "Não conseguimos encontrar o produto que você está procurando",
  imageCreateError: "Erro ao criar a imagem do produto.",
  imageUpdateError: "Erro ao atualizar a imagem do produto.",
  
  // Validation Messages
  codeRequiredForSku: "Os campos Código e Nome/Título são obrigatórios. Por favor, preencha o campo Código para continuar.",
  titleRequiredForSku: "Os campos Código e Nome/Título são obrigatórios. Por favor, preencha o campo Nome/Título para continuar.",
  codeAndTitleRequiredForSku: "Por favor, preencha os campos obrigatórios Código e Nome/Título antes de criar variações (SKU).",
};
